export const moveElementToFirst = (data, propertyName, propertyValue) => {
  const first = data.find(item => item[propertyName] === propertyValue)
  const filtered = data.filter(item => item[propertyName] !== propertyValue)

  filtered.unshift(first)

  return filtered
}
